module.exports = __webpack_public_path__ + "static/media/icon-facebook.9636f5d6.svg";